import * as TY from 'containers/pages/users/constants';

const makeUserObj = (user, newFileId) => {
	let mstCustId = null;
	const mapCompanyIds = user[TY.COMPANIES].map((company) => company.Id);
	const mapContactTypeIds = user[TY.CONTACT_TYPES].map((type) => type.Id);
	const mapLanguageIds = user[TY.LANGUAGES].map((lanuages) => lanuages?.id);
	const mapRoleIds = user[TY.ROLES].map((role) => role?.id);

	user[TY.MST_CUST_ID].Id === '0'
		? (mstCustId = '')
		: (mstCustId = user[TY.MST_CUST_ID].Id);

	const userObj = {
		Id: user[TY.ID],
		ContactId: user[TY.CONTACT_ID],
		FirstName: user[TY.F_NAME],
		LastName: user[TY.L_NAME],
		Customers: mapCompanyIds,
		VFileId: newFileId,
		Image: {
			file: user[TY.IMAGE].file,
			name: user[TY.IMAGE].name,
			preview: user[TY.IMAGE].preview,
		},
		WorkEmail: user[TY.EMAIL_WORK],
		PersonalEmail: user[TY.EMAIL_PERSONAL],
		OtherEmail: user[TY.EMAIL_OTHER],
		ContactTypes: mapContactTypeIds,
		WorkPhone: user[TY.PHONE_WORK].number,
		WorkPhoneDialCode: user[TY.PHONE_WORK].dialCode,
		WorkPhoneCountryCode: user[TY.PHONE_WORK].countryCode,
		WorkPhoneExtension: user[TY.PHONE_WORK].ext,
		CellPhone: user[TY.PHONE_MOBILE].number,
		CellPhoneDialCode: user[TY.PHONE_MOBILE].dialCode,
		CellPhoneCountryCode: user[TY.PHONE_MOBILE].countryCode,
		CellPhoneExtension: user[TY.PHONE_MOBILE].ext,
		HomePhone: user[TY.PHONE_OTHER].number,
		HomePhoneDialCode: user[TY.PHONE_OTHER].dialCode,
		HomePhoneCountryCode: user[TY.PHONE_OTHER].countryCode,
		HomePhoneExtension: user[TY.PHONE_OTHER].ext,
		Note: user[TY.NOTE],
		Addresses: [
			{
				address_id: user[TY.ADDRESS_WORK].address_id,
				type: user[TY.ADDRESS_WORK].type,
				street:
					user[TY.ADDRESS_WORK].street +
					', ' +
					user[TY.ADDRESS_WORK].unit,
				city: user[TY.ADDRESS_WORK].city,
				province: user[TY.ADDRESS_WORK].province,
				country: user[TY.ADDRESS_WORK].country,
				postalCode: user[TY.ADDRESS_WORK].postalCode,
				placeId: user[TY.ADDRESS_WORK].placeId,
				lat: user[TY.ADDRESS_WORK].coordinate?.lat,
				lng: user[TY.ADDRESS_WORK].coordinate?.lng,
			},
			{
				address_id: user[TY.ADDRESS_HOME].address_id,
				type: user[TY.ADDRESS_HOME].type,
				street:
					user[TY.ADDRESS_HOME].street +
					', ' +
					user[TY.ADDRESS_HOME].unit,
				city: user[TY.ADDRESS_HOME].city,
				province: user[TY.ADDRESS_HOME].province,
				country: user[TY.ADDRESS_HOME].country,
				postalCode: user[TY.ADDRESS_HOME].postalCode,
				placeId: user[TY.ADDRESS_HOME].placeId,
				lat: user[TY.ADDRESS_HOME].coordinate?.lat,
				lng: user[TY.ADDRESS_HOME].coordinate?.lng,
			},
			{
				address_id: user[TY.ADDRESS_OTHER].address_id,
				type: user[TY.ADDRESS_OTHER].type,
				street:
					user[TY.ADDRESS_OTHER].street +
					', ' +
					user[TY.ADDRESS_OTHER].unit,
				city: user[TY.ADDRESS_OTHER].city,
				province: user[TY.ADDRESS_OTHER].province,
				country: user[TY.ADDRESS_OTHER].country,
				postalCode: user[TY.ADDRESS_OTHER].postalCode,
				placeId: user[TY.ADDRESS_OTHER].placeId,
				lat: user[TY.ADDRESS_OTHER].coordinate?.lat,
				lng: user[TY.ADDRESS_OTHER].coordinate?.lng,
			},
		],
		Languages: mapLanguageIds,
		UserName: user[TY.U_NAME],
		UserPassword: user[TY.PWD],
		ConfirmPassword: user[TY.CONFIRM_PWD],
		IsEnabled: user[TY.IS_ENABLED],
		MasterCustomerId: mstCustId,
		UserRoles: mapRoleIds,
		PostLoginAppId: user[TY.POST_LOGIN_APP_ID] || null,
	};
	return userObj;
};

export default makeUserObj;
